import script from "./chooseTeam.vue?vue&type=script&lang=ts&setup=true"
export * from "./chooseTeam.vue?vue&type=script&lang=ts&setup=true"

import "./chooseTeam.vue?vue&type=style&index=0&id=76610541&lang=less&scoped=true"

import exportComponent from "/root/djmesweb-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76610541"]])

export default __exports__